import { FC, PropsWithChildren } from "react";

// Way to turn on and off features
// Decides on what kind of environment we are running -- production, staging or dev

// Usage:

// import { isEnabled, IfFeatureEnabled } from './features';

// if (isEnabled('deleteRasterEdits')) { ... }

// <IfFeatureEnabled feature="deleteRasterEdits">...</IfFeatureEnabled>

type Feature = "deleteRasterEdits" | "deleteObstacleEdits";

export function isEnabled(feature: Feature): boolean {
  const featuresDisabled = DISABLED_FEATURES[ENVIRONMENT];
  return !featuresDisabled.includes(feature);
}

interface IfFeatureEnabledProps {
  feature: Feature;
}

export const IfFeatureEnabled: FC<PropsWithChildren<IfFeatureEnabledProps>> = ({
  feature,
  children,
}) => (isEnabled(feature) ? <>{children}</> : null);

// The below are internal to this module

type FeaturesDisabled = Feature[];

interface FeaturesDisabledPerEnvironment {
  production: FeaturesDisabled;
  staging: FeaturesDisabled;
  development: FeaturesDisabled;
}

type Environment = keyof FeaturesDisabledPerEnvironment;

const DISABLED_FEATURES: FeaturesDisabledPerEnvironment = {
  production: ["deleteRasterEdits", "deleteObstacleEdits"],
  staging: ["deleteRasterEdits", "deleteObstacleEdits"],
  development: [],
};

const HOSTNAME = window.location.hostname;
// For dev work it is also possible to change this temporarily, e.g.
const ENVIRONMENT: Environment = HOSTNAME.includes("dev.")
  ? "development"
  : HOSTNAME.includes("staging.")
  ? "staging"
  : "production";
